import { Form, Formik } from 'formik';
import { Props, Values } from './CurrencyRatesForm.types';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';
import { convertEnumToArray, ObjectFromEnum } from '../../utils/functions/data.functions';
import { RateModel } from '../../types/Currency';
import { dateSubmitFormat } from '../../types/core/date.types';
import format from 'date-fns/format';
import { useEffect, useRef } from 'react';
import { useTranslation } from '../../context/translationContext';

/**
 * Form component to edit / create Currency rates for company
 */
export const CurrencyRatesForm = ({ onSubmit, initialValues, onBack }: Props) => {
  const { t } = useTranslation();
  const formRef = useRef<any>();
  const _initialValues: Values = {
    rateModel: RateModel.DAILY,
    validFrom: format(new Date(), dateSubmitFormat),
  };

  const validationSchema = Yup.object().shape({
    rateModel: Yup.string().required('Rate model is required.'),
    validFrom: Yup.string().required('Valid from date is required.'),
  });

  useEffect(() => {
    if (!initialValues) return;
    formRef.current.setFieldValue(
      'validFrom',
      format(new Date(initialValues.validFrom), dateSubmitFormat),
    );
  }, []);

  return (
    <Formik
      innerRef={formRef}
      enableReinitialize
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ errors, touched, setFieldValue }) => (
        <Form className="w-full">
          <div className="my-4">
            <FormField
              id="validFrom"
              name="validFrom"
              label={t('page.currency-rates.col-valid-from')}
              type="date"
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <span>{t('page.currency-rates.col-rate-model')}</span>
            <FormField
              type="select"
              id="rateModel"
              name="rateModel"
              onChange={(e) => {
                if (!e.target.value) return;
                setFieldValue('rateModel', e.target.value);
              }}
            >
              {convertEnumToArray(RateModel).map((opt: ObjectFromEnum, index: number) => (
                <option key={index} value={opt.value}>
                  {opt.name}
                </option>
              ))}
            </FormField>
          </div>
          <div className='flex'>
            <Button title={t('general.back')} color="gray" className="mr-3" onClick={onBack} />
            <Button title={t('general.save')} type="submit" color="green" showLoading />
          </div>
        </Form>
      )}
    </Formik>
  );
};
